import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { logout } from '../services/api';

const LogoutPage: React.FC = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const performLogout = async () => {
      try {
        await logout();
        setIsLoggingOut(false);
      } catch (err: any) {
        setError('Failed to logout properly. Redirecting anyway...');
        // Even if there's an error, we'll redirect after a short delay
        setTimeout(() => setIsLoggingOut(false), 2000);
      }
    };

    performLogout();
  }, []);

  if (!isLoggingOut) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="app-container">
      <header className="app-header">
        <h1>Google Drive Task Manager</h1>
      </header>
      <main className="login-container">
        <h2>Logging Out</h2>
        <p>Please wait while we sign you out...</p>
        {error && <div className="error-message">{error}</div>}
      </main>
    </div>
  );
};

export default LogoutPage; 